<template>
  <ul
    class="user-menu"
    ref="userMenu"
    v-click-outside="closeMenu"
    v-show="showMenu"
  >
    <li class="user-menu__item" @click="logoutUser">
      {{ $t("user-menu.logout") }}
    </li>
    <li class="user-menu__item" @click="updateStatus">
      {{ active ? "Stand-by" : "Activo" }}
    </li>
    <li class="user-menu__item">
      <a
        href="https://blog.heycenter.com/preguntas-frecuentes/"
        target="_blank"
        rel="noopener"
      >FAQ.</a
      >
    </li>
  </ul>
</template>

<script>
import { gsap } from 'gsap';
import { mapGetters, mapMutations } from 'vuex';
import vClickOutside from 'v-click-outside';
import { OPEN_USER_MENU } from '@/eventTypes';
import { onLogout } from '@/vue-apollo';
import EventBus from '@/eventBus';
import apolloProvider from '@/apollo';
import userChangeStatus from '@/graphql/mutations/userChangeStatus.gql';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      showMenu: false,
      start: { x: 0, y: 0, opacity: 1 },
      end: { opacity: 0, x: -100 },
      timeline: gsap.timeline({ defaults: { duration: 0.7 } }),
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    status() {
      return this.active ? 'STANDBY' : 'ONLINE';
    },
    active() {
      return this.userInfo.status === 'online';
    },
  },
  created() {
    EventBus.$on(OPEN_USER_MENU, () => {
      this.openUserMenu();
    });
  },
  destroyed() {
    EventBus.$off(OPEN_USER_MENU);
  },
  methods: {
    ...mapMutations({
      setUser: 'setUser',
    }),
    async updateStatus() {
      await this.changeStatus(this.status);
      this.openUserMenu();
    },
    changeStatus(status) {
      return this.$apollo.mutate({
        mutation: userChangeStatus,
        variables: {
          id: this.userInfo.id,
          status,
        },
      });
    },
    async logoutUser() {
      await this.changeStatus('OFFLINE');
      onLogout(apolloProvider.defaultClient);
    },
    async closeMenu(e) {
      // TODO review if this is working as intended
      if (this.showMenu && e.target.id !== 'user_image') {
        this.openUserMenu();
      }
    },
    async openUserMenu() {
      if (this.showMenu) {
        await this.animate(this.start, this.end);
        this.showMenu = false;
      } else {
        this.showMenu = true;
        this.animate(this.end, this.start);
      }
    },
    animate(first, second) {
      return this.timeline.fromTo(this.$refs.userMenu, first, second);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/_user_menu.scss";
</style>
